export function getAuthConfig(token, config = {}) {
    const headers = {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...(config.headers || {}),
    };

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    return {
        ...config,
        headers,
    };
}

let isHandlingJwtError = false;

const jwtErrorMessages = [
    'authorization header is required',
    'authorization header must use the bearer scheme',
    'token is missing from the authorization header',
    'token has expired',
    'token is invalid',
    'token could not be parsed',
    'user not found for the provided token',
    'unauthenticated',
];

function getResponseMessage(error) {
    const data = error && error.response ? error.response.data : null;

    if (!data) {
        return '';
    }

    if (typeof data === 'string') {
        return data;
    }

    return data.error || data.message || '';
}

function clearAuthStorage() {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('org_id');
    localStorage.removeItem('name');
    localStorage.removeItem('id');
    localStorage.removeItem('module_access');
    localStorage.removeItem('isAuthenticated');
}

function redirectToFrontPage(vm) {
    const isWebView = /MyAppWebView/i.test(navigator.userAgent);
    const path = isWebView ? '/login' : '/';

    if (vm && vm.$router) {
        const navigation = vm.$router.push({ path });
        if (navigation && navigation.catch) {
            navigation.catch(() => {});
        }
        return;
    }

    window.location.href = path;
}

export function handleJwtError(vm, error) {
    const status = error && error.response ? error.response.status : null;
    const message = getResponseMessage(error);
    const normalizedMessage = message.toLowerCase();
    const isJwtMessage = jwtErrorMessages.some(jwtMessage => normalizedMessage.indexOf(jwtMessage) > -1);

    if (![401, 403, 404].includes(status) || !isJwtMessage) {
        return false;
    }

    if (isHandlingJwtError) {
        return true;
    }

    isHandlingJwtError = true;

    const alert = vm && vm.$swal ? vm.$swal : null;
    const shownAlert = alert ? alert({
        title: 'Sesi Bermasalah',
        text: message || 'Sesi login tidak valid. Silakan login kembali.',
        icon: 'warning',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
    }) : Promise.resolve();

    Promise.resolve(shownAlert).then(() => {
        clearAuthStorage();
        redirectToFrontPage(vm);
        isHandlingJwtError = false;
    }, () => {
        isHandlingJwtError = false;
    });

    return true;
}
